Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.ShowPdpCaption = Marionette.Behavior.extend({
        initialize: function() {
            this.view.templateHelpers = this.view.templateHelpers || {};
            Cocktail.mixin(this.view.templateHelpers, this.templateHelpers);
        },
        templateHelpers: {
            isPdpCaption: function(){
                return !_.isFalsy(App.displayOptions.get("pdpCaption"));
            },
            getPdpCaption: function(){
                var pdpCaption = App.displayOptions.get("pdpCaption");
                return App.request("decode:utf8", pdpCaption);
            }
        }
    });
});
